import styled from 'styled-components';
import { useTextVariant } from '../../../../hook/useTextVariant';
import { END_CONSTANTS } from '../../../../constants/end';

export const EndMobile = ({
  goOfflineTab,
  isEarlyEnd,
}: {
  goOfflineTab: () => void;
  isEarlyEnd: boolean;
}) => {
  const { getText } = useTextVariant(END_CONSTANTS, true);

  return (
    <>
      <EndContainer isEarlyEnd={isEarlyEnd}>
        {isEarlyEnd && <EarlyEnd>{getText('earlyEnd')}</EarlyEnd>}
        <EndText isEarlyEnd={isEarlyEnd}>
          {isEarlyEnd ? getText('endEarlyText') : getText('endText')}
        </EndText>
        <EndDesc>{getText('endDesc')}</EndDesc>
        <EndSubText>{getText('endSubText')}</EndSubText>
      </EndContainer>
      <BottomTabContainer onClick={goOfflineTab}>
        <GoTournamentBtn>{getText('btnText')}</GoTournamentBtn>
      </BottomTabContainer>
    </>
  );
};

const EarlyEnd = styled.h4`
  color: #ba8484;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 38px; /* 237.5% */
  letter-spacing: -0.32px;
  margin-bottom: 10px;
`;

const EndDesc = styled.h4`
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  line-height: 135.39%; /* 27.078px */
  letter-spacing: -1.2px;
  white-space: pre-wrap;
  margin-bottom: 30px;

  width: 310px;
  border-radius: 10px;
  border-bottom: 1px solid #484848;
  background: rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.2) inset;
  padding: 16px 20px 18px 20px;
  margin: 20px auto;
`;

const EndSubText = styled.h4`
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: -0.36px;

  span {
    color: rgba(255, 241, 201, 0.8);
    border-bottom: 1px solid rgba(255, 241, 201, 0.8);
    font-weight: 500;
  }
`;

const EndText = styled.h3<{ isEarlyEnd: boolean }>`
  color: ${({ isEarlyEnd }) => (isEarlyEnd ? '#FF6062' : 'rgba(255, 255, 255, 0.7)')};
  text-align: center;
  font-size: 26px;
  font-weight: 500;
  line-height: 34px;
  letter-spacing: -1.56px;
  margin-bottom: 10px;
`;

const EndContainer = styled.div<{ isEarlyEnd?: boolean }>`
  flex: 1;
  padding-bottom: 100px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: ${({ isEarlyEnd }) => (isEarlyEnd ? 10 : 57)}px;
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const GoTournamentBtn = styled.button`
  height: 70px;
  width: 100%;
  cursor: pointer;
  box-shadow: 0px 1px 0px 0px rgba(255, 183, 183, 0.3) inset;
  background: linear-gradient(90deg, rgba(182, 0, 88, 0.85) 39.5%, rgba(174, 11, 114, 0.85) 100%);
  backdrop-filter: blur(25px);
  font-weight: 600;
  font-size: 21px;
  line-height: 28px;
  letter-spacing: -0.04em;
  color: #ffffff;
`;
